module.exports = "<div class=\"alert-container\">\r\n  <div *ngFor=\"let alert of alerts\" class=\"{{ cssClass(alert) }} alert-dismissible\">\r\n    <span class=\"mr-5\">{{alert.message}}</span>\r\n    <a class=\"close\" (click)=\"removeAlert(alert)\">&times;</a>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/alert/alert.component.html
// module id = ../../../../../src/app/widgets/alert/alert.component.html
// module chunks = main